import http from "./configServices/httpService";
import { base_url } from "./configServices/config";

// Auth Services
export const loginService = (data) => {
  return http.post(`${base_url}/auth/login`, data);
};
// End Auth

// Start Upload
export const uploadUserService = (data) => {
  return http.post(`${base_url}/user/upload`, data, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};
// End Upload
